import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

import item1 from './../../img/tutorial/1@3x.png';
import item2 from './../../img/tutorial/2@3x.png';
import item3 from './../../img/tutorial/3@3x.png';


class TutorialStep5 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step5)}>

        <div className={classnames(baseStyles.tutorial_subtitle)}>
          <p><b>1 double-spaced page = 300 words</b></p>
          <p><span className={baseStyles.text_extradanger}>Not meeting the word count will result in a FAILED assignment</span></p>
        </div>

        <p className={baseStyles.tutorial_desc}>Words are counted starting from the first word of introduction to the last word of conclusion. <br/>
          Please, note that the title page, abstract, reference page, and the footnotes <br/> are <b>NOT</b> included in the word count.</p>

        <i className={baseStyles.tutorial_devider} />

        <div className={classnames(grid.row, baseStyles.item_block)}>
          <img src={item1} alt="item1" height="60px" />
          <div>
            <h3>Introduction 10%</h3>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Presents a brief overview of the problem/background information;</li>
              <li>Finishes with a strong thesis statement;</li>
              <li>Includes a thesis statement which is arguable and to the point.</li>
            </ul>
          </div>
        </div>

        <div className={classnames(grid.row, baseStyles.item_block)}>
          <img src={item2} alt="item2" height="60px" />
          <div>
            <h3>Main Body 80%</h3>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Each paragraph begins with a topic sentence further supported with interpreted <br /> evidence and finishes with a transition sentence;</li>
              <li>Each paragraph should be dedicated just to one idea;</li>
              <li>Each paragraph MUST contain at least 3 sentences and be up to 200 words.</li>
            </ul>
          </div>
        </div>


        <div className={classnames(grid.row, baseStyles.item_block)}>
          <img src={item3} alt="item3" height="60px" />
          <div>
            <h3>Conclusion 10%</h3>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Restates the thesis statement;</li>
              <li>Summarizes key points stated in the body paragraphs;</li>
              <li>Contains NO new information, no references.</li>
            </ul>
          </div>
        </div>

      </div>
    )
  }
}

export default TutorialStep5;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep5.js